/**
 * Who may download a completed (in-site) ACR for a product from a public surface (the product
 * detail page and the Product Listing page). This is a UI gate only; the API must still enforce
 * access on the underlying report/catalog requests.
 * - Superuser: any completed report.
 * - Vendor for the product's org: any completed report (public or not).
 * - Agency for the product's org: any completed report (public or not).
 * - Any other vendor / agency (buyer): only if the report is public.
 */
export default function canDownloadProductAcr({
  isSuperUser,
  isVendorUser,
  isAgencyUser,
  userVendorId,
  productVendorId,
  userAgencyId,
  productAgencyId,
  reportIsPublic,
}) {
  if (isSuperUser) return true;
  if (
    isVendorUser
    && userVendorId != null
    && productVendorId != null
    && String(userVendorId) === String(productVendorId)
  ) {
    return true;
  }
  if (
    isAgencyUser
    && userAgencyId != null
    && productAgencyId != null
    && String(userAgencyId) === String(productAgencyId)
  ) {
    return true;
  }
  if (isVendorUser && reportIsPublic === true) {
    return true;
  }
  if (isAgencyUser && reportIsPublic === true) {
    return true;
  }
  return false;
}
